
export class SelectModel {

  constructor(
    public id: string,
    public title: string
  ) {  }
}
